// TODO: Delete when added to orion and the latest version in installed
import React from 'react';

const BankIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 22C2 21.4477 2.44772 21 3 21H21C21.5523 21 22 21.4477 22 22C22 22.5523 21.5523 23 21 23H3C2.44772 23 2 22.5523 2 22Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10C6.55228 10 7 10.4477 7 11V18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18V11C5 10.4477 5.44772 10 6 10Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 10C10.5523 10 11 10.4477 11 11V18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18V11C9 10.4477 9.44772 10 10 10Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 10C14.5523 10 15 10.4477 15 11V18C15 18.5523 14.5523 19 14 19C13.4477 19 13 18.5523 13 18V11C13 10.4477 13.4477 10 14 10Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18.5523 10 19 10.4477 19 11V18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18V11C17 10.4477 17.4477 10 18 10Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.47 1.152C11.7942 0.949333 12.2057 0.949333 12.53 1.152L20.53 6.152C20.9083 6.38844 21.0842 6.84686 20.9612 7.27568C20.8382 7.7045 20.4461 8 20 8H3.99996C3.55385 8 3.1617 7.7045 3.03871 7.27568C2.91573 6.84686 3.09166 6.38844 3.46996 6.152L11.47 1.152ZM7.48676 6H16.5132L12 3.17925L7.48676 6Z"
        fill="black"
      />
    </svg>
  );
};

export default BankIcon;
